import "flag-icons/css/flag-icons.min.css";
import { ImgHTMLAttributes } from "react";

import styled from "styled-components";

import getCountry from "~/data/getCountry";

const LogoContainer = styled.div`
  position: relative;
`;

const CompanyLogoImage = styled.img`
  position: absolute;
  display: block;
  background-color: ${(props) => props.theme.colors.white};
  border: 0.2px solid #babcba;
  box-shadow: inset 0px 0px 2px rgba(0, 0, 0, 0.25);
  border-radius: 50%;
  width: 100%;
  height: 100%;
  object-fit: cover;
  flex-shrink: 0;
`;

const FlagIcon = styled.span`
  position: absolute;
  right: 2px;
  bottom: 8px;
  width: 24px;
  height: 18px;
  box-shadow: 1px 1px 4px 0px;
  background-size: cover;
`;

type CompanyLogoProps = ImgHTMLAttributes<HTMLImageElement> & { jurisdictions?: string; jurisdictionsStyle?: any };

CompanyLogo.defaultProps = {
  src: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
};

export default function CompanyLogo(props: CompanyLogoProps) {
  const { jurisdictions, jurisdictionsStyle } = props;
  const country = jurisdictions ? getCountry(jurisdictions) : null;
  const flagIcon = country ? (
    <FlagIcon
      data-testid={`flag-${jurisdictions}`}
      style={jurisdictionsStyle}
      className={`fi fi-${jurisdictions?.toLowerCase()}`}
      title={country}
    />
  ) : null;

  return (
    <LogoContainer className={`${props.className}`}>
      <CompanyLogoImage {...props} data-testid="vasp-logo-image" />
      {flagIcon}
    </LogoContainer>
  );
}
